import { jsx } from "react/jsx-runtime";
import StyledTooltip from "../../../../../components/styled-tooltip/styled-tooltip.js";
import { InsuranceType } from "../../../../../type/Appointment.js";
import { useLabels } from "../../labels.provider.js";
import { IconButton, StyledInsuranceProofIcon } from "./insurance-proof.styles.js";
import "@mui/material";
import "react";
import "@mui/material/styles";
import "../../assets/icons/InsuranceProofIcon.js";
const InsuranceProof = ({ insuranceType, insuranceScannedInCurrentQuarter }) => {
  const { labels } = useLabels();
  const isValidInsuranceType = insuranceType && [InsuranceType.SOCIAL_INSURANCE, InsuranceType.ADDITIONAL_PRIVATE_INSURANCE].includes(insuranceType);
  if (!isValidInsuranceType) {
    return null;
  }
  const hasValidInsuranceProof = Boolean(insuranceScannedInCurrentQuarter);
  return /* @__PURE__ */ jsx(StyledTooltip, { title: labels.insuranceProofState[hasValidInsuranceProof ? "valid" : "invalid"], placement: "top", children: /* @__PURE__ */ jsx(IconButton, { valid: hasValidInsuranceProof, children: /* @__PURE__ */ jsx(StyledInsuranceProofIcon, { valid: hasValidInsuranceProof }) }) });
};
export {
  InsuranceProof as default
};
